// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Base Layout --- */
.hp-container {
    display: flex;
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* --- Hero Section (Left side) --- */
.hp-hero-section {
    flex: 1.2 1;
    display: flex;
    align-items: center;
    justify-content: flex-end; 
    padding-right: 100px; 
    padding-left: 10px;
    color: white;
}

.hp-hero-content {
    max-width: 550px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.hp-logo-img {
    width: 130px;
    height: auto;
    margin-bottom: 10px;
    border-radius: 8px;
}

.hp-title {
    font-size: 24px;
    margin-top: 10px;
    line-height: 1.2;
    font-weight: bold;
}

.hp-highlight {
    color: #ffd700; /* Gold highlight */
}

.hp-sub-brand {
    color: #ffd700;
    font-size: 2.2rem;
    font-weight: bold;
    margin-top: 5px;
    margin-bottom: 10px;
}

.hp-slogan {
    font-style: italic;
    color: #cbd5e1;
    font-size: 1.1rem;
    margin-top: 10px;
    border-left: none; 
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 10px;
}

.hp-features {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: fit-content;
}

.hp-text {
    font-size: 1.1rem;
    margin-top: 10px;
    opacity: 0.9;
    line-height: 1.6;
}

.hp-footer-text {
    margin-top: 50px;
    font-size: 12px;
    opacity: 0.6;
    letter-spacing: 1px;
}

/* --- Login Wrapper (Right side) --- */
.hp-login-wrapper {
    flex: 1 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.login-card {
    background: white;
    padding: 2.5rem;
    border-radius: 12px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    width: 100%;
    max-width: 400px;
}

.login-title {
    text-align: center;
    margin-bottom: 2rem;
    color: #1f2937;
    font-size: 1.5rem;
    font-weight: 600;
}

.login-input-group {
    margin-bottom: 1.25rem;
}

.login-input-field {
    width: 100%;
    padding: 12px 15px;
    margin-bottom: 15px; /* ইনপুট ফিল্ডের নিচের গ্যাপ সামান্য কমানো হয়েছে */
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 16px;
    box-sizing: border-box;
    transition: border-color 0.3s ease;
}

.login-input-field:focus {
    border-color: #3b82f6;
    outline: none;
}

.login-password-wrapper {
    position: relative;
}

.login-password-toggle {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #6b7280;
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 1.1rem;
}

.login-button-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1.5rem;
}

.login-btn-primary {
    background: #3b82f6;
    color: white;
    padding: 0.75rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: background 0.3s;
}

.login-btn-primary:hover {
    background: #2563eb;
}

.login-btn-secondary {
    background: #10b981;
    color: white;
    padding: 0.75rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 600;
    transition: background 0.3s;
}

.login-btn-secondary:hover {
    background: #059669;
}

.login-lang-section {
    margin-top: 1.5rem;
    text-align: center;
}

.login-lang-select {
    padding: 0.4rem;
    border-radius: 4px;
    border: 1px solid #d1d5db;
    cursor: pointer;
    background: #f9fafb;
}



/* --- Responsive View --- */
@media (max-width: 992px) {
    .hp-container {
        flex-direction: column;
    }
    .hp-hero-section {
        padding: 60px 20px;
        text-align: center;
        justify-content: center; 
    }
    .hp-hero-content {
        max-width: 100%;
    }
    .hp-title {
        font-size: 2.2rem;
    }
    .hp-login-wrapper {
        padding-bottom: 60px;
    }
    .hp-slogan {
        border-left: none;
        border-top: 2px solid #3b82f6;
        padding-left: 0;
        padding-top: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;IACI,aAAa;IACb,iBAAiB;IACjB,6DAA6D;IAC7D,4DAA4D;AAChE;;AAEA,qCAAqC;AACrC;IACI,WAAS;IACT,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc,EAAE,mBAAmB;AACvC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,8CAA8C;IAC9C,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,SAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB,EAAE,kDAAkD;IACvE,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;AACvB;;;;AAIA,4BAA4B;AAC5B;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,iBAAiB;QACjB,6BAA6B;QAC7B,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["/* --- Base Layout --- */\n.hp-container {\n    display: flex;\n    min-height: 100vh;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* --- Hero Section (Left side) --- */\n.hp-hero-section {\n    flex: 1.2;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end; \n    padding-right: 100px; \n    padding-left: 10px;\n    color: white;\n}\n\n.hp-hero-content {\n    max-width: 550px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.hp-logo-img {\n    width: 130px;\n    height: auto;\n    margin-bottom: 10px;\n    border-radius: 8px;\n}\n\n.hp-title {\n    font-size: 24px;\n    margin-top: 10px;\n    line-height: 1.2;\n    font-weight: bold;\n}\n\n.hp-highlight {\n    color: #ffd700; /* Gold highlight */\n}\n\n.hp-sub-brand {\n    color: #ffd700;\n    font-size: 2.2rem;\n    font-weight: bold;\n    margin-top: 5px;\n    margin-bottom: 10px;\n}\n\n.hp-slogan {\n    font-style: italic;\n    color: #cbd5e1;\n    font-size: 1.1rem;\n    margin-top: 10px;\n    border-left: none; \n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n    padding-top: 10px;\n}\n\n.hp-features {\n    margin-top: 15px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    width: fit-content;\n}\n\n.hp-text {\n    font-size: 1.1rem;\n    margin-top: 10px;\n    opacity: 0.9;\n    line-height: 1.6;\n}\n\n.hp-footer-text {\n    margin-top: 50px;\n    font-size: 12px;\n    opacity: 0.6;\n    letter-spacing: 1px;\n}\n\n/* --- Login Wrapper (Right side) --- */\n.hp-login-wrapper {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n.login-card {\n    background: white;\n    padding: 2.5rem;\n    border-radius: 12px;\n    box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n    width: 100%;\n    max-width: 400px;\n}\n\n.login-title {\n    text-align: center;\n    margin-bottom: 2rem;\n    color: #1f2937;\n    font-size: 1.5rem;\n    font-weight: 600;\n}\n\n.login-input-group {\n    margin-bottom: 1.25rem;\n}\n\n.login-input-field {\n    width: 100%;\n    padding: 12px 15px;\n    margin-bottom: 15px; /* ইনপুট ফিল্ডের নিচের গ্যাপ সামান্য কমানো হয়েছে */\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 16px;\n    box-sizing: border-box;\n    transition: border-color 0.3s ease;\n}\n\n.login-input-field:focus {\n    border-color: #3b82f6;\n    outline: none;\n}\n\n.login-password-wrapper {\n    position: relative;\n}\n\n.login-password-toggle {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    color: #6b7280;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    font-size: 1.1rem;\n}\n\n.login-button-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    margin-top: 1.5rem;\n}\n\n.login-btn-primary {\n    background: #3b82f6;\n    color: white;\n    padding: 0.75rem;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background 0.3s;\n}\n\n.login-btn-primary:hover {\n    background: #2563eb;\n}\n\n.login-btn-secondary {\n    background: #10b981;\n    color: white;\n    padding: 0.75rem;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: background 0.3s;\n}\n\n.login-btn-secondary:hover {\n    background: #059669;\n}\n\n.login-lang-section {\n    margin-top: 1.5rem;\n    text-align: center;\n}\n\n.login-lang-select {\n    padding: 0.4rem;\n    border-radius: 4px;\n    border: 1px solid #d1d5db;\n    cursor: pointer;\n    background: #f9fafb;\n}\n\n\n\n/* --- Responsive View --- */\n@media (max-width: 992px) {\n    .hp-container {\n        flex-direction: column;\n    }\n    .hp-hero-section {\n        padding: 60px 20px;\n        text-align: center;\n        justify-content: center; \n    }\n    .hp-hero-content {\n        max-width: 100%;\n    }\n    .hp-title {\n        font-size: 2.2rem;\n    }\n    .hp-login-wrapper {\n        padding-bottom: 60px;\n    }\n    .hp-slogan {\n        border-left: none;\n        border-top: 2px solid #3b82f6;\n        padding-left: 0;\n        padding-top: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
